import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { Package, PackageReqBody } from '../../../types/packages';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const usePackageActions = (whichAction: 'packageList' | '') => {
  // query function to fetch all the packages from the database declared here
  const getPackageListHandler = useQuery({
    queryKey: ['package-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Package>>> => {
      const response = await getPrivateAxiosInstance('finance').get(
        '/credit/package/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'packageList'),
  });

  // mutation function to create new package declared here
  const createNewPackageHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: PackageReqBody;
    }): Promise<AcademiaResponse<Package>> => {
      const response = await getPrivateAxiosInstance('finance').post(
        '/credit/package/create/',
        body
      );

      return response.data;
    },
  });

  // mutation function to update existing package by id declared here
  const updatePackageHandler = useMutation({
    mutationFn: async ({
      packageId,
      body,
    }: {
      packageId: number;
      body: PackageReqBody;
    }): Promise<AcademiaResponse<Package>> => {
      const response = await getPrivateAxiosInstance('finance').patch(
        `/credit/package/${packageId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  // mutation function to delete packages by id declared here
  const deletePackageByIdHandler = useMutation({
    mutationFn: ({
      packageId,
    }: {
      packageId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('finance').delete(
        `/credit/package/${packageId}/delete/`
      ),
  });

  return {
    getPackageListHandler,
    createNewPackageHandler,
    updatePackageHandler,
    deletePackageByIdHandler,
  };
};

export default usePackageActions;
